<template>
  <div class="t-bg--gray-100">
    <Loader v-if="!loaded || isLoading" color="#009aa3" />
    <SortingHeader v-show="loaded && !isLoading" />
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import SortingHeader from '@/components/Listing/SortingHeader.vue'
import Loader from '@/components/Listing/Loader.vue'

export default {
  components: { SortingHeader, Loader },
  computed: Object.assign(mapGetters(['isLoading']), mapState(['isLoading']), {
    loaded() {
      return this.$store.state.loaded
    },
  }),
}
</script>
